<template>
  <v-app>
    <TheHeader :key="$route.fullPath" />
    <v-main>
      <router-view></router-view>
    </v-main>
    <TheFooter />
  </v-app>
</template>

<script>
import TheHeader from './components/TheHeader.vue';
import TheFooter from "@/components/TheFooter.vue";

export default {
  components: {
    TheHeader,
    TheFooter
  },
  // watch: {
  //   '$route.fullPath'() {
  //     window.scrollTo({
  //       top: 0,
  //       left: 0,
  //       behavior: 'smooth'
  //     });
  //   }
  // },
}
</script>

<style scoped>
.v-main {
  min-height: 97vh;
}
</style>
